import { atom } from "recoil";

export const highlightPointsState = atom({
  key: 'highlightPointsState',
  default: []
});